import React, { forwardRef, useCallback, useState } from 'react'
import { RadioGroup, Text, Stack, Form } from 'rsuite'
import AnnotatedRadio from './AnnotatedRadio'
import {
    constructMarkup,
    isNullUndefinedOrEmptyString,
    unescapeConfigString,
} from '../../common/utils'
import FormFieldErrorIcon from './FormFieldErrorIcon'


const RadioGroupWithErrorStatus = React.memo(
    forwardRef(
        (
            {
                onChange,
                options,
                defaultOption,
            },
            ref
        ) => {


            return (
                <RadioGroup
                    onChange={(v) => {
                        onChange(v)
                    }}
                    value={defaultOption?.key}
                >
                    {options?.map((opt, idx) => {
                        let hasAnnotationText = !isNullUndefinedOrEmptyString(opt.description)
                        let optionKey = opt.key
                        return (
                            <AnnotatedRadio
                                key={`radio_option_${optionKey}_${idx}`}
                                value={optionKey}
                                label={`${opt.label}`}

                                annotation={() =>
                                    hasAnnotationText ? (
                                        <Text>
                                            {opt.description}
                                        </Text>
                                    ) : null
                                }
                            />
                        )
                    })}
                </RadioGroup>
            )

        }
    )
);



const RadioQuestionGroup = ({
    name,
    title = '',
    description = '',
    options,
    defaultOption,
    onChange,
    hasError,
    validationRule,
    errorMessage = "",
    hideErrorIcon = false,
    ...rest
}) => {
    const RadioGroupWithErrorStateAndProps = useCallback(
        (props) => (
            <RadioGroupWithErrorStatus
                {...props}
                showError={hasError}
                errorMessage={errorMessage}
                hideErrorIcon={hideErrorIcon}
                options={options}
                defaultOption={defaultOption}
                onChange={changedInternal}
            />
        ),
        [hasError, errorMessage, hideErrorIcon, defaultOption, options]
    );
    const [isChanged, setIsChanged] = useState(false);

    const changedInternal = (v) => {
        setIsChanged(true);
        onChange(v)
    }

    return (
        <>
            <Stack direction="row" {...rest}>
                <Stack direction="column" alignItems='flex-start'>
                    {
                        title && title.length > 0 && (
                            <Text className="text-bold">{title}</Text>
                        )
                    }
                    {
                        description && description.length > 0 && (
                            <Text>{description}</Text>
                        )
                    }
                    <Form.Control
                        name={name}
                        rule={validationRule}
                        errorMessage={errorMessage}
                        accepter={RadioGroupWithErrorStateAndProps}
                        value={rest.value}
                        {...rest}
                    />
                </Stack>
                {
                    hasError && !isChanged && <FormFieldErrorIcon errorMessage={errorMessage} />
                }
            </Stack>


        </>
    )
}

export default RadioQuestionGroup
